<template>
    <div class="rounded-card border border-panel-border bg-panel p-4">
        <div class="grid grid-cols-1 gap-3 lg:grid-cols-2">
            <div>
                <jet-input
                    :model-value="name"
                    :horizontal="false"
                    :invalidFeedback="errors.name"
                    :label="labels.name"
                    :placeholder="placeholders.name"
                    :required="required.name"
                    class="mb-0"
                    @update:modelValue="$emit('update:name', $event)"
                >
                    <template #prepend>
                        <icon name="cil-user" />
                    </template>
                </jet-input>
            </div>
            <div>
                <jet-input
                    :model-value="role"
                    :horizontal="false"
                    :invalidFeedback="errors.role"
                    :label="labels.role"
                    :placeholder="placeholders.role"
                    :required="required.role"
                    class="mb-0"
                    @update:modelValue="$emit('update:role', $event)"
                >
                    <template #prepend>
                        <icon name="cil-briefcase" />
                    </template>
                </jet-input>
            </div>
            <div>
                <jet-input
                    :model-value="email"
                    :horizontal="false"
                    :invalidFeedback="errors.email"
                    :label="labels.email"
                    :placeholder="placeholders.email"
                    :required="required.email"
                    class="mb-0"
                    @update:modelValue="$emit('update:email', $event)"
                >
                    <template #prepend>
                        <icon name="cil-envelope-closed" />
                    </template>
                </jet-input>
            </div>
            <div>
                <jet-input
                    :model-value="phone"
                    :horizontal="false"
                    :invalidFeedback="errors.phone"
                    :label="labels.phone"
                    :placeholder="placeholders.phone"
                    :required="required.phone"
                    class="mb-0"
                    @update:modelValue="$emit('update:phone', $event)"
                >
                    <template #prepend>
                        <icon name="cil-phone" />
                    </template>
                </jet-input>
            </div>
        </div>

        <div v-if="showInformationalCheckbox || $slots.actions" class="mt-3 flex items-center justify-between gap-3">
            <div v-if="showInformationalCheckbox" class="flex items-center gap-2">
                <jet-checkbox
                    :label="informationalLabel"
                    :model-value="isInformational"
                    @update:model-value="$emit('update:isInformational', $event)"
                />
                <info-icon v-if="informationalTooltip" :tooltip="informationalTooltip" />
            </div>

            <div v-if="$slots.actions" class="ml-auto flex justify-end">
                <slot name="actions" />
            </div>
        </div>
    </div>
</template>

<script setup>
import InfoIcon from '@/Components/InfoIcon.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import JetInput from '@/Jetstream/Input.vue';
import { trans } from '@/mixins/i18n.js';

defineEmits(['update:name', 'update:role', 'update:email', 'update:phone', 'update:isInformational']);

defineProps({
    name: { type: String, default: '' },
    role: { type: String, default: '' },
    email: { type: String, default: '' },
    phone: { type: String, default: '' },
    isInformational: { type: Boolean, default: false },
    showInformationalCheckbox: { type: Boolean, default: false },
    informationalLabel: {
        type: String,
        default: 'Informational contact',
    },
    informationalTooltip: {
        type: String,
        default: '',
    },
    errors: {
        type: Object,
        default: () => ({
            name: '',
            role: '',
            email: '',
            phone: '',
        }),
    },
    labels: {
        type: Object,
        default: () => ({
            name: trans('stakeholders.form.contact_name.label'),
            role: trans('stakeholders.form.description.label'),
            email: trans('stakeholders.form.email.primary.label'),
            phone: trans('stakeholders.form.phone.label'),
        }),
    },
    placeholders: {
        type: Object,
        default: () => ({
            name: trans('stakeholders.form.contact_name.placeholder'),
            role: trans('stakeholders.form.description.placeholder'),
            email: trans('stakeholders.form.email.placeholder'),
            phone: trans('stakeholders.form.phone.placeholder'),
        }),
    },
    required: {
        type: Object,
        default: () => ({
            name: false,
            role: false,
            email: false,
            phone: false,
        }),
    },
});
</script>
